<template lang="html">
  <v-layout wrap>
    <v-flex
      xs12
      class="mb-3">
      The calendar is currently under construction.
      <br/>
      We'll keep you updated!
      <br/>
      We apologize for any inconvenience.
      <!-- <v-sheet
        :elevation="elevation"
        dark>
        <v-layout wrap align-center>
          <v-flex xs4 class="text-xs-left">
            <v-btn
              @click="prev"
              flat
              color="primary">
              <v-icon
                right>
                mdi-chevron-left
              </v-icon>
              Prev
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-xs-center"> {{ monthString }} {{ year }} </v-flex>
          <v-flex xs4 class="text-xs-right">
            <v-btn
              @click="next"
              flat
              color="primary">
              Next
              <v-icon
                right>
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-calendar
              ref="calendar"
              v-model="start"
              :end="end"
              :color="color"
              dark>
              <template #day=" { date } ">
                <template v-for="ev in eventsMap[date]">
                  <v-menu
                    :key="`${ev.type}-${ev.title}-${ev.date}`"
                    full-width
                    offset-x>
                    <template #activator=" { on } ">
                      <v-btn
                        v-if="!ev.time"
                        v-on="on"
                        :color="ev.color"
                        flat
                        small>
                        {{ ev.title }}
                      </v-btn>
                    </template>
                    <v-card
                      color="grey lighten-4"
                      max-width="500px"
                      min-width="250px"
                      flat>
                      <v-card-title primary-title>
                        <div class="headline"> {{ ev.date }} </div>
                      </v-card-title>
                      <v-card-text>
                        <busie-rate-card :rate="ev.data"/>
                      </v-card-text>
                      <v-card-actions>
                        <rate-select
                          v-model="selectedRate"
                          :rates="selectableRates"
                          @continue="selectRateHandler(ev.dateId)"/>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </template>
              </template>
            </v-calendar>
          </v-flex>
        </v-layout>
      </v-sheet> -->
    </v-flex>
  </v-layout>
</template>

<script>
// import RateCard from './RateCard'
// import RateSelect from './RateSelect'
// import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    // 'busie-rate-card': RateCard,
    // 'rate-select': RateSelect
  },
  data: () => ({
    elevation: 24,
    selectedRate: {},
    color: 'primary',
    start: '',
    end: '',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    month: 0,
    year: 0
  }),
  computed: {
    querystring () {
      // let y = this.year
      // let m = this.month
      // let d = this.dispatch
      // return `?date__year=${y}&date__month=${m}&dispatch=${d}`
    },
    monthString () {
      // return this.months[ this.month - 1 ]
    },
    rateEvents () {
      // let m = this.month
      // let y = this.year
      // return this.calendarDates.filter(
      //   d => d.date.split('-')[0] == y && d.date.split('-')[1] == m).map(
      //     date => ({
      //       dateId: date.id,
      //       date: date.date,
      //       title: date.rate ? this.rateById(date.rate).name : 'No Rate',
      //       data: date.rate ? this.rateById(date.rate) : {},
      //       type: 'rate',
      //       color: 'primary',
      //     })
      // )
    },
    eventsMap () {
      // const map = {}
      // this.rateEvents.forEach(ev => (map[ev.date] = map[ev.date] || []).push(ev))
      // return map
    },
    selectableRates () {
      // return this.savedRates.map(rate => ({text: rate.name, value: rate.id}))
    },
    // ...mapGetters('rates', { rateById: 'byId', savedRates: 'saved' }),
    // ...mapGetters('dispatch', { dispatch: 'id' }),
    // ...mapGetters('calendar', { calendarDates: 'all' })
  },
  mounted () {
    // this.month = this.$refs.calendar.start.split('-')[1]
    // this.year = this.$refs.calendar.start.split('-')[0]
    // this.toggleLoading()
    // this.updateView()
  },
  methods: {
    next () {
      // this.month++
      // if (this.month === 13) {
      //   this.month = 1
      //   this.year++
      // }
      // this.toggleLoading()
      // return this.updateView().then(() => this.$refs.calendar.next())
    },
    prev () {
      // this.month--
      // if (this.month === 0) {
      //   this.month = 12
      //   this.year--
      // }
      // this.toggleLoading()
      // return this.updateView().then(() => this.$refs.calendar.prev())
    },
    selectRateHandler (date) {
      // const payload = {
      //   id: date,
      //   rate: this.selectedRate
      // }
      // return this.updateDate(payload).then(() => {
      //   this.toggleLoading()
      //   this.updateView()
      // }).catch(e => this.raiseError(e))
    },
    updateView () {
      // this.updateProgress(1/2)
      // const vm = this
      // return this.fetchCalendarDates(this.querystring).then(() => {
      //   vm.updateProgress(1/1)
      //   setTimeout(() => {
      //     vm.toggleLoading()
      //     vm.updateProgress(0)
      //   }, 500)
      // }).catch(e => {
      //   vm.updateProgress(Infinity)
      //   vm.raiseError(e)
      //   setTimeout(() => {
      //     vm.toggleLoading()
      //     vm.updateProgress(0)
      //   }, 500)
      // })
    },
    // ...mapActions('dates', { updateDate: 'update' }),
    // ...mapActions('app', [ 'raiseError', 'toggleLoading', 'updateProgress' ]),
    // ...mapActions('calendar', { fetchCalendarDates: 'fetchAll' })
  }
}
</script>

<style lang="css" scoped>
</style>
